import isArray from 'lodash/isArray';

export const parseClient = client => {
	let templates = client.templates;
	if (!isArray(templates)) {
		if (!client.templates || client.templates === '') templates = [];
		else templates = JSON.parse(templates);
	}
	return {
		...client,
		templates,
	};
};

export const CLIENT = `
	query client($id: Uint) {
		client(id: $id) {
			id
			name
			templates
			domains {
				id
				app_name
				bundle_id
				branding
				plists
				updated_at
			}
			created_at
			events {
				id
				name
				event_image_url
			}
			admins {
				id
				email
			}
		}
	}
`;

export const CLIENTS = `
	query clients {
		clients {
			id
			name
			templates
			domains {
				id
				app_name
				bundle_id
				branding
				plists
				updated_at
			}
			created_at
			admins {
				id
				email
			}
		}
	}
`;
